/**
 * 数学
 */
export const MATH = {
  // 正常四舍五入，如：1.354保留两位是1.35；1.355保留两位是1.36；
  ROUND: 0,
  // 向下舍出，如：1.354保留两位是1.35；1.355保留两位是1.35；
  ROUND_FLOOR: 1,
};
